import React from 'react'
import classnames from 'classnames'
import { Avatar } from '@myxplor/ui'
import AuthorisedBadge from './badge'
import ConditionalLink from './conditional-link'
import './auth-personnel.css'

const ViewPerson = ({
  id,
  authorised_id,
  first_name,
  last_name,
  gov_person_registrations,
  onClick,
  loading = false
}) => {

  const isAuthorised = (authorised_id === id)
  const clickable = (!loading && !isAuthorised)

  return (
    <li className={classnames({
      'authorised-person': true,
      'authorised-person__clickable': clickable,
      'authorised-person__authorised': isAuthorised
    })}
    onClick={event => {
      event.preventDefault()
      return !loading ? onClick(id) : null
    }}
    >
      <Avatar user={{
        first_name,
        last_name
      }}
      />
      <div>
        <ConditionalLink isLink={clickable}>
          <div className="authorised-person__name">{first_name} {last_name}</div>
        </ConditionalLink>
        <p className="authorised-person__gov_id">CCMS Personnel ID: {
          gov_person_registrations.map((val, i) => (
            <code key={`authorised-person__${i}`}>{val.gov_id}</code>
          ))
        }
        </p>
      </div>

      <AuthorisedBadge authorised={isAuthorised} />
    </li>
  )
}

export default ViewPerson


// WEBPACK FOOTER //
// ./src/auth-personnel/views/view.jsx